export default (permalink, photo, title, categories, btn, linkedin) => `
<div class="single-person person-hv">
    <a href="${permalink}" class="person-wrapper">
        <div class="photo-wrapper">
            <div class="person-photo" style="background: url(${photo}) center / cover no-repeat;">
            </div>
         </div>
         <div class="about-overlay-bg">
            <div class="about-person">
                <div class="person-name">
                    <h4>${title}</h4>
                </div>
                <div class="additional-info">
                    ${categories.map(category => `
                        <div class="info rounded-wrap">
                            <span>${category}</span>
                        </div>
                    `).join('')}
                </div>
                <div class="learn-more-button">
                    <span>${btn}</span>
                </div>
            </div>
         </div>
    </a>
    <div class="linkedin">
        ${linkedin ? `<a href="${linkedin}" target="_blank">
            <svg id="linkedin_2_" data-name="linkedin (2)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.493 13.493">
                <path id="Path_93" data-name="Path 93" d="M17.206,16.809h0V11.86c0-2.421-.521-4.286-3.351-4.286a2.938,2.938,0,0,0-2.646,1.454h-.039V7.8H8.489v9.008h2.794V12.348c0-1.174.223-2.31,1.677-2.31,1.433,0,1.454,1.34,1.454,2.385v4.386Z" transform="translate(-3.716 -3.316)" fill="#fff"></path>
                <path id="Path_94" data-name="Path 94" d="M.4,7.977h2.8v9.008H.4Z" transform="translate(-0.173 -3.492)" fill="#fff"></path>
                <path id="Path_95" data-name="Path 95" d="M1.62,0a1.628,1.628,0,1,0,1.62,1.62A1.621,1.621,0,0,0,1.62,0Z" transform="translate(0 0)" fill="#fff"></path>
            </svg>
        </a>` : ''}
    </div>
</div>

`